import axios from 'axios'
import Base from './Config'
import React, { Component,useState  } from 'react';

import { Modal,ButtonToolbar,Button } from 'react-bootstrap';
import { WaveLoading,
} from 'react-loadingg';
// import 'bootstrap/dist/css/bootstrap.min.css';

import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import LocationPicker from 'react-location-picker';


import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
// If you want to use the provided css
//import 'react-google-places-autocomplete/dist/index.min.css';// import { geocodeByAddress } from 'react-google-places-autocomplete';
import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';



// import { GoogleComponent } from 'react-google-location' 

const API_KEY = "AIzaSyCXIHUZIYRTgbs-c0ABxbpBqmNhhqa-ShY"  // how to get key - step are below

const defaultPosition = {
    lat: 25.3548,
    lng: 51.1839
  };
   

export default class componentName extends Component {
    constructor(){
        super()
        this.state={
            name: "",
            arname: "",
            username: "",
            mobile: "",
            password: "",
            cpassword: "",
            email: "",
            address: "",
            araddress: "",
            ex_date:"",
            notification_date:"",
            countrycode:"+974",

            location:"",
            building_no:"",
            door_no:"",
            land_mark:"",
            streat:"",
            latitude:25.3548,
            longitude:51.1839,
            place:"",

            place: "Kala Pattar Ascent Trail, Khumjung 56000, Nepal",
            position: {
                lat: 25.3548,
                lng: 51.1839
            },
            API_KEY:"",
        }
        this.handleLocationChange = this.handleLocationChange.bind(this);
    }
    
  componentDidMount(){
    //   this.fetchGoogleMapApiKey()
  }

    fetchGoogleMapApiKey(){
        axios.get(
            Base.url + 'Configurations/',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response.data.results);

            this.setState({
                API_KEY:response.data.results[8].param_value,
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    handleLocationChange ({ position, place, places }) {
        console.log('possition ',position);
        console.log('place ',place);
        console.log('places ',places);
        
        // Set new location
        this.setState({ position, place,latitude:position.lat,longitude:position.lng });
    }
 
      
    clearState=()=>{
        this.setState({
            name: "",
            arname: "",
            username: "",
            mobile: "",
            password: "",
            cpassword: "",
            email: "",
            address: "",
            araddress: "",
            ex_date:"",
            notification_date:"",

            location:"",
            building_no:"",
            door_no:"",
            land_mark:"",
            streat:"",
            latitude:25.3548,
            longitude:51.1839,

            
        })
    }
    submitForm=()=>{
        // console.log('number',this.state.countrycode+this.state.mobile);
        // return false
        
        // console.log('worked ',this.props);
        // console.log('data : ',this.state);
        // return false
        // console.log('state ',this.state);
        if(this.state.name==""){
            NotificationManager.warning("Required"," Name",10000)
            return false
        }
        if(this.state.arname==""){
            NotificationManager.warning("Required"," Arabic name",10000)
            return false
        }
        if(this.state.username==""){
            NotificationManager.warning("Required"," Username",10000)
            return false
        }
        if(this.state.mobile==""){
            NotificationManager.warning("Required"," Mobile",10000)
            return false
        }
        if(this.state.password==""){
            NotificationManager.warning("Required","Password",10000)
            return false
        }
        if(this.state.cpassword==""){
            NotificationManager.warning("Required"," Confirm Password",10000)
            return false
        }

        if(this.state.email==""){
            NotificationManager.warning("Required"," Email address",10000)
            return false
        }
        if(this.state.ex_date==""){
            NotificationManager.warning("Required"," User leaving date",10000)
            return false
        }
        if(this.state.notification_date==""){
            NotificationManager.warning("Required"," Notifiy admin on",10000)
            return false
        }
        if(this.state.latitude==""){
            NotificationManager.warning("Required","latitude",10000)
            return false
        }
        if(this.state.longitude==""){
            NotificationManager.warning("Required","longitude",10000)
            return false
        }
        if(!(this.state.password==this.state.cpassword)){
            NotificationManager.info("Invalid password"," Password do not match",10000)
            return false
        }

        if(this.state.cpassword === this.state.password){
            var bodyFormData = new FormData();
            bodyFormData.set('name', this.state.name);
            bodyFormData.set('name_in_arabic', this.state.arname);
            bodyFormData.set('username', this.state.username);
            bodyFormData.set('mobile', this.state.countrycode+this.state.mobile);
            bodyFormData.set('password', this.state.password);
            bodyFormData.set('user_type', 'T');
            bodyFormData.set('email', this.state.email);
            bodyFormData.set('ex_date', this.state.ex_date+" 00:00:00");
            bodyFormData.set('notification_date', this.state.notification_date+" 00:00:00");

            // for (var pair of bodyFormData.entries()) {
            //     console.log(pair[0] + ', ' + pair[1]);
            //   }
            axios.post(
                Base.url + 'User/',
                bodyFormData,
            {
                    headers: {
                        'Authorization': 'Token ' + localStorage.getItem('Token'),
                    }
                }
            )
            .then(response =>{
                // console.log('response : ',response);
                // console.log('response : ',response.data.id);
                    if(response.data.Status){

                        // NotificationManager.success( 'response.data.Message','Success : ',3000)
                        
                        var bodyFormDataAddress = new FormData();
                        bodyFormDataAddress.set('location', this.state.location);
                        bodyFormDataAddress.set('building_no', this.state.building_no);
                        bodyFormDataAddress.set('door_no', this.state.door_no);
                        bodyFormDataAddress.set('land_mark', this.state.land_mark);
                        bodyFormDataAddress.set('streat', this.state.streat);
                        bodyFormDataAddress.set('latitude', this.state.latitude);
                        bodyFormDataAddress.set('longitude', this.state.longitude);
                        bodyFormDataAddress.set('tenant_id', response.data.id);

                        axios.post(
                            Base.url + 'Address/',
                            bodyFormDataAddress,
                        {
                                headers: {
                                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                                }
                            }
                        )
                        .then(response =>{
                            // console.log('response : ',response);
                                if(response.data.Status){
                                    // console.log("True ",response);

                                    NotificationManager.success( "User created",'Success : ',3000)
                                    this.clearState()
                                }else{
                                    // console.log("false ",response);
                                    NotificationManager.error('Error : ', response.data.Error, 3000)
                                }
                        })
                        .catch(error=>{
                            console.log(error);
                        })

                    }else{
                        console.log(response.data.Message);
                        NotificationManager.error(response.data.Message, response.data.Error, 3000)
                    }
            })
            .catch(error=>{
                console.log(error);
            })
        }
        else{

            NotificationManager.info('Info ','Password donot match', 3000)
        }
    }

    onChange=(e)=>{
        this.setState ({
            [e.target.name]:e.target.value
        })
    }

    getLatLng=(name)=>{
        // // console.log(name.description);
        
        // geocodeByAddress(name.description)
        // .then(results => console.log(results[0]))
        // .catch(error => console.error(error));

        geocodeByAddress(name.description)
        .then(results => getLatLng(results[0]))
        .then(({ lat, lng }) =>{
                console.log('Successfully got latitude and longitude', { lat, lng })
                this.setState({
                  latitude:lat,
                  longitude:lng  
                })
            }
            
        );


    }


    render() {
        // console.log('place ',this.state.place);
        // console.log('lat ',this.state.place.coordinates.lat);
        // console.log('lon ',this.state.place.coordinates.lon);
        
        return (
            <div>
            {/* <NotificationContainer/> */}

            <NavigationItems />
            {/* Main content */}
            <div className="main-content">
            <PageHeader pageName='Create Tenant' />

            <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                <div className="container-fluid">
                    <div className="header-body">
                        {/* Card stats */}
                        <div className="row">
                            <div className="col-xl-3 col-lg-6">
                            </div>
                            <div className="col-xl-3 col-lg-6">
                            </div>
                            <div className="col-xl-3 col-lg-6">
                            </div>
                            <div className="col-xl-3 col-lg-6">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Page content */}
            <div className="container-fluid mt--9">
                <div className="row">

                <div className="col-xl-12 order-xl-1">
                    <div className="card bg-secondary shadow">
                    <div className="card-header bg-white border-0">
                        <div className="row align-items-center">
                        <div className="col-8">
                            <h3 className="mb-0">Create Tenant</h3>
                        </div>
                        <div className="col-4 text-right">
                        <button className="btn btn-sm btn-danger" onClick={this.clearState}>Cancel</button>

                        <button className="btn btn-sm btn-primary" onClick={this.submitForm}>Create</button>
                        </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="pl-lg-4">
                            <div className="row">
                            <div className="col-lg-6">
                                <div className="form-group">
                                <label className="form-control-label" htmlFor="input-username">Name * </label>
                                <input name="name" value={this.state.name} onChange={this.onChange} type="text" className="form-control form-control-alternative" placeholder="First Name" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                <label className="form-control-label" htmlFor="input-email">Arabic name *</label>
                                <input name="arname" value={this.state.arname} onChange={this.onChange} placeholder="Arabic name" type="email" id="input-email" className="form-control form-control-alternative"   />
                                </div>
                            </div>
                            </div>
                            <div className="row">
                            <div className="col-lg-6">
                                <div className="form-group">
                                <label className="form-control-label" htmlFor="input-username">Username *</label>
                                <input name="username" value={this.state.username} onChange={this.onChange}  type="text"  className="form-control form-control-alternative" placeholder="Username" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="col-md-6">
                                    <base-input placeholder="name@example.com"></base-input>
                                </div>
                                <div className="col-md-6">
                                    <base-input placeholder="Disabled" disabled></base-input>
                                </div>

                                <div className="form-group">
                                <label className="form-control-label" htmlFor="input-email">Mobile *</label>
                                <table>
                                    <tbody>
                                    <tr>
                                        <td colSpan="1">
                                        <input disabled name="countrycode" value={this.state.countrycode} onChange={this.onChange} size="4" type="text" className="form-control form-control-alternative"   />
                                        </td>
                                        <td colSpan="3">
                                        <input name="mobile" value={this.state.mobile} size="70" onChange={this.onChange} type="text" placeholder="Mobile Numer" className="form-control form-control-alternative"   />
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                
                                </div>
                            </div>
                            </div>
                            <div className="row">
                            <div className="col-lg-6">
                                <div className="form-group">
                                <label className="form-control-label" htmlFor="input-username">Password *</label>
                                <input name="password" value={this.state.password} onChange={this.onChange} type="password"  className="form-control form-control-alternative" placeholder="Password" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                <label className="form-control-label" htmlFor="input-email">Confirm Password *</label>
                                <input name="cpassword" value={this.state.cpassword} onChange={this.onChange} placeholder="Confirm Password" type="password" className="form-control form-control-alternative"   />
                                </div>
                            </div>
                            
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-username" title="Date of user leaving">User leaving date *</label>
                                    <input className="form-control" type="date" value={this.state.ex_date} onChange={(event) => this.setState({ex_date: event.target.value,download:false})}/>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-email" title="Email will be send to admin before leaving this user">Notify admin on *</label>
                                    <input className="form-control" type="date" value={this.state.notification_date} onChange={(event) => this.setState({notification_date: event.target.value,download:false})}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-email">Email address *</label>
                                    <input name="email" value={this.state.email} onChange={this.onChange} placeholder="Email address" className="form-control form-control-alternative"   />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-username">Location</label>
                                    <input name="location" value={this.state.location} onChange={this.onChange} placeholder="Location" type="text" className="form-control form-control-alternative" />
                                    </div>
                                </div>
                            </div>
                            
                            
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-username">Building Number</label>
                                    <input name="building_no" value={this.state.building_no} onChange={this.onChange} placeholder="Building number"  type="text" className="form-control form-control-alternative" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-email">Door Number</label>
                                    <input  name="door_no" value={this.state.door_no} onChange={this.onChange} placeholder="Door number" type="text" className="form-control form-control-alternative"   />
                                    </div>
                                </div>
                            </div>

                            
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-username">Landmark</label>
                                    <input name="land_mark" value={this.state.land_mark} onChange={this.onChange} placeholder="Landmark"  type="text" className="form-control form-control-alternative" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-email">Street</label>
                                    <input name="streat" value={this.state.streat} onChange={this.onChange} placeholder="Street" type="text" className="form-control form-control-alternative"   />
                                    </div>
                                </div>
                            </div>
                            <br/>
                            {/* <h1  className="form-control-label">Enter location</h1> */}

                            <div className="row">
{/*                                 
                                <div className="col-lg-3">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-username">Select Place</label>
                                    <GoogleComponent
                                        locationBoxStyle="form-control form-control-alternative"
                                        apiKey={API_KEY}
                                        language={'en'}
                                        country={'country:in|country:us'}
                                        coordinates={true}
                                        // locationBoxStyle={'custom-style'}
                                        // locationListStyle={'custom-style-list'}
                                        onChange={(e) => { this.setState({ place: e },()=>{
                                            // console.log('e ',e);
                                            if(e.coordinates){
                                                this.setState({
                                                    latitude:e.coordinates.lat,
                                                    longitude:e.coordinates.lng,
                                                })
                                            }
                                            
                                        }) }} />
                                        
                                    </div>
                                </div> */}
{/* 
                                <div className="col-lg-2">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-username">Or</label>
                                    
                                    </div>
                                </div> */}



                                <div className="col-lg-6">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-username">Latitude *</label>
                                    <input name="latitude" value={this.state.latitude} onChange={this.onChange} placeholder="Latitude"  type="text" className="form-control form-control-alternative" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                    <label className="form-control-label" htmlFor="input-email">Longitude *</label>
                                    <input name="longitude" value={this.state.longitude} onChange={this.onChange} placeholder="Longitude" type="text" className="form-control form-control-alternative"   />
                                    </div>
                                </div>
                            </div>

                            
                                <div>
                                <GooglePlacesAutocomplete
                                    onSelect={(val)=>this.getLatLng(val)}
                                    autocompletionRequest={{
                                        location:"",
                                        componentRestrictions:{
                                            country: ['qa'],
                                            }
                                        }}
                                        
                                />


                                <LocationPicker
                                    containerElement={ <div style={ {height: '100%'} } /> }
                                    mapElement={ <div style={ {height: '500px'} } /> }
                                    defaultPosition={{lat:this.state.latitude,lng:this.state.longitude}}
                                    onChange={this.handleLocationChange}
                                />
                                </div>
                            

                            <div className="row">
                                <div className="col-lg-6">
                                    
                                </div>
                                <div className="col-6 text-right">
                                <button className="btn btn-lg btn-danger" onClick={this.clearState}>Cancel</button>
                                <button className="btn btn-lg btn-primary" onClick={this.submitForm}>Create</button>
                                </div>
                            </div>
                            <div className="row">
                           
                            </div>

                        </div>
                        
                    </div>

                    </div>

                </div>
                
                </div>
                <Footer />
            </div>
            </div>
        </div>
        );
    }
}